import { render } from "./Info.vue?vue&type=template&id=5e801b94&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=5e801b94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e801b94"

export default script